import { BASE_URL } from '@/constants/env'
import { useUserStoreWithOut } from '@/store/modules/user'
import axios, { AxiosInstance, InternalAxiosRequestConfig, AxiosResponse, AxiosRequestConfig } from 'axios'
import { ElMessage } from 'element-plus'

const getToken = () => {
  const userStore = useUserStoreWithOut()
  return userStore.token;
}
// 创建axios实例
const axiosInstance: AxiosInstance = axios.create({
  baseURL: BASE_URL,
  timeout: 10000,
  headers: {
    'Content-Type': 'application/json',
  },
})

// 请求拦截器
axiosInstance.interceptors.request.use(
  (config: InternalAxiosRequestConfig) => {
    // 在发送请求之前做些什么
    const token = getToken()
    if (token && config.headers) {
      config.headers.Authorization = `Bearer ${token}`
    }
    // 如果是 FormData，删除 Content-Type，让浏览器自动设置（包含 boundary）
    if (config.data instanceof FormData) {
      delete config.headers['Content-Type']
    }
    // 移除请求体中的时间戳字段（由数据库自动管理）
    if (config.data && typeof config.data === 'object') {
      const { createdAt, updatedAt, ...restData } = config.data;
      config.data = restData;
    }
    return config
  },
  (error) => {
    // 对请求错误做些什么
    return Promise.reject(error)
  },
)

// 响应拦截器
axiosInstance.interceptors.response.use(
  (response: AxiosResponse) => {
    // blob 类型直接返回（文件下载等场景）
    if (response.config.responseType === 'blob') {
      return response.data
    }
    // 对响应数据做点什么
    const { data } = response
    if (data.code !== 200) {
      ElMessage.error(data.message || '请求失败')
      return Promise.reject(new Error(data.message || '请求失败'))
    }
    return data
  },
  (error) => {
    // 对响应错误做点什么
    if (error.response) {
      const { status, data } = error.response
      const userStore = useUserStoreWithOut()
      switch (status) {
        case 401:
          ElMessage.error('未授权，请重新登录')
          userStore.reset();
          break
        case 403:
          ElMessage.error(data?.message || '没有权限访问该资源')
          break
        case 404:
          ElMessage.error('请求地址出错')
          break
        case 500:
          ElMessage.error('服务器内部错误')
          break
        default:
          ElMessage.error(data?.message || '请求失败')
      }
    } else {
      ElMessage.error('网络错误')
    }
    return Promise.reject(error)
  },
)

/**
 * 支持泛型的请求函数
 * @param url 请求地址
 * @param config 请求配置
 * @returns Promise<T> 返回指定类型的数据
 */
function request<T = any>(url: string, config?: AxiosRequestConfig): Promise<T> {
  return axiosInstance.request<T, T>({
    url,
    ...config,
  })
}

export default request
